// @ts-nocheck
import * as React from "react";

const GridLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4l.005-.15A2 2 0 0 1 5 13Zm10 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4l.005-.15A2 2 0 0 1 15 13ZM9 15H5v4h4v-4Zm10 0h-4v4h4v-4ZM9 3a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5l.005-.15A2 2 0 0 1 5 3Zm10 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5l.005-.15A2 2 0 0 1 15 3ZM9 5H5v4h4V5Zm10 0h-4v4h4V5Z"
            />
        </svg>
    );
};

export default React.memo(GridLine);
